import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router'
import { GetData } from '../Api'
var _ = require('lodash');

function CheckLogin() {
  const [userSession, setuserSession] = useState(false);
  const [processing, setprocessing] = useState(true);

  const IdentifyUser = () => {
    GetData('api/auth/user', true).then(() => {
      setuserSession(true);
      setprocessing(false);
    }).catch(()=>{
      setuserSession(false);
      setprocessing(false);
    });
  }

  const IdentifyToken = () => {
    let token = localStorage.getItem("token");
    if(_.isEmpty(token)){
      setuserSession(false);
      setprocessing(false);
    }else{
      IdentifyUser();
    }
  }

  useEffect(() => {
    IdentifyToken();
  }, [])

  return !processing ? (userSession ? <Redirect to="dashboard" /> : <Redirect to="login" />) : null;
}

export default CheckLogin;